import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { IvfRequirementsInfo } from "carrot-api/types/IvfRequirementsInfo"
import ResponseError from "../../../../types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import { HttpStatusCodes } from "../../../../utils/HttpStatusCodes"

function useIvfRequirementsInfoQuery<TData>(
  select?: (data: IvfRequirementsInfo) => TData
): UseQueryResult<TData, ResponseError> {
  return useQuery<IvfRequirementsInfo, ResponseError, TData>({
    queryFn: () => carrotClient.getIvfRequirementsInfo(),
    queryKey: ["GetIvfRequirementsInfoForCurrentUser"],
    select,
    retry: (failureCount, error) => {
      switch (error.statusCode) {
        case HttpStatusCodes.UNAUTHORIZED:
        case HttpStatusCodes.FORBIDDEN:
        case HttpStatusCodes.BAD_REQUEST:
        case HttpStatusCodes.NOT_FOUND:
          return false
        default:
          return failureCount <= 3
      }
    }
  })
}

type IvfRequirementsInfoResult = {
  hasCompletedIvfRequirements: boolean
  ivfRequirementsInfo: IvfRequirementsInfo
}

export function useIvfRequirementsInfo(): UseQueryResult<IvfRequirementsInfoResult, ResponseError> {
  return useIvfRequirementsInfoQuery((data: IvfRequirementsInfo) => ({
    hasCompletedIvfRequirements:
      !data.hasIvfRequirements || (data.hasUpcomingOrCompletedChat && data.hasIvfConsentSignature),
    ivfRequirementsInfo: data
  }))
}
